import React, { useState, useEffect } from 'react';
import './VersionSelector.css';
import { apiGet, apiPatch } from '../services_1/apiClient';

const VersionSelector = ({ onSelectionChange }) => {
  const [versions, setVersions] = useState([]);
  const [selectedVersions, setSelectedVersions] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [stats, setStats] = useState({ total: 0, locked: 0 });

  const fetchVersions = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await apiGet('/api/forecast-versions');
      const list = Array.isArray(data) ? data : (data.versions || []);
      setVersions(list);
      setStats({
        total: list.length,
        locked: list.filter(v => v.locked).length,
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVersions();
  }, []);

  const handleVersionChange = (event) => {
    const versionId = event.target.value;
    const isChecked = event.target.checked;

    let newSelectedVersions;
    if (isChecked) {
      newSelectedVersions = [...selectedVersions, versionId];
    } else {
      newSelectedVersions = selectedVersions.filter((id) => id !== versionId);
    }

    // Limit selection to 5 versions
    if (newSelectedVersions.length > 5) {
      return;
    }

    setSelectedVersions(newSelectedVersions);
    onSelectionChange(newSelectedVersions);
  };

  const toggleLock = async (versionId, currentLocked) => {
    const action = currentLocked ? 'unlock' : 'lock';
    try {
      await apiPatch(`/api/forecast-versions/${versionId}/${action}`);
      fetchVersions();
    } catch (err) {
      console.error(err);
      setError(`Failed to ${action} version.`);
    }
  };

  return (
    <div className="version-selector">
      <div className="version-header">
        <h3>Compare Forecast Versions</h3>
        <span className="version-stats">
          {stats.locked} locked / {stats.total} total
        </span>
      </div>
      {isLoading && <p>Loading versions...</p>}
      {error && <p className="error">Error: {error}</p>}
      <div className="version-list">
        {versions.map((version) => (
          <div key={version.version_id} className={`version-item ${version.locked ? 'is-locked' : ''}`}>
            <input
              type="checkbox"
              id={version.version_id}
              value={version.version_id}
              checked={selectedVersions.includes(version.version_id)}
              onChange={handleVersionChange}
            />
            <label htmlFor={version.version_id} className="version-info">
              <span className="version-name">{version.name}</span>
              <span className="version-date">
                {new Date(version.created_at).toLocaleString()}
              </span>
            </label>
            <button 
              className={`lock-btn ${version.locked ? 'locked' : 'unlocked'}`}
              onClick={(e) => {
                e.preventDefault();
                toggleLock(version.version_id, version.locked);
              }}
            >
              {version.locked ? '🔒 Locked' : '🔓 Unlocked'}
            </button>
          </div>
        ))}
      </div>
      <div className="version-actions">
        <button onClick={fetchVersions} disabled={isLoading} className="refresh-btn">
          Refresh Versions
        </button>
        <div className="selection-count">
          {selectedVersions.length} selected (max 5)
        </div>
      </div>
    </div>
  );
};

export default VersionSelector;
